export const TRAVEL_ROUTES_DATA_WINGIE = {
  en: [
    {
      topDomesticFlight: {
        type: 'topDomesticFlights',
        title: 'Top domestic flights',
      },
    },
    {
      TopDestinationsWorldwide: {
        type: 'topDestinationsWorldwide',
        title: 'Top destinations worldwide',
      },
    },
    {
      PopularCountries: {
        type: 'popularCountries',
        title: 'Popular countries',
      },
    },
  ],
  de: [
    {
      topDomesticFlight: {
        type: 'topDomesticFlights',
        title: 'Populäre Inlandsflüge',
      },
    },
    {
      TopDestinationsWorldwide: {
        type: 'topDestinationsWorldwide',
        title: 'Top internationale Reiseziele',
      },
    },
    {
      PopularCountries: {
        type: 'popularCountries',
        title: 'Beliebte Länder',
      },
    },
  ],
  es: [
    {
      topDomesticFlight: {
        type: 'topDomesticFlights',
        title: 'Vuelos domésticos populares',
      },
    },
    {
      TopDestinationsWorldwide: {
        type: 'topDestinationsWorldwide',
        title: 'Los mejores destinos del mundo',
      },
    },
    {
      PopularCountries: {
        type: 'popularCountries',
        title: 'Países populares',
      },
    },
  ],
  ru: [
    {
      topDomesticFlight: {
        type: 'topDomesticFlights',
        title: 'Популярные внутренние рейсы',
      },
    },
    {
      TopDestinationsWorldwide: {
        type: 'topDestinationsWorldwide',
        title: 'Основные направления по всему миру',
      },
    },
    {
      PopularCountries: {
        type: 'popularCountries',
        title: 'Популярные страны',
      },
    },
  ],
  ar: [
    {
      topDomesticFlight: {
        type: 'topDomesticFlights',
        title: 'أشهر الوجهات الداخلية',
      },
    },
    {
      TopDestinationsWorldwide: {
        type: 'topDestinationsWorldwide',
        title: 'أشهر الوجهات الدولية',
      },
    },
    {
      PopularCountries: {
        type: 'popularCountries',
        title: 'أشهر الدول',
      },
    },
  ],
  az: [
    {
      topDomesticFlight: {
        type: 'topDomesticFlights',
        title: 'Ən populyar daxili istiqamətlər',
      },
    },
    {
      TopDestinationsWorldwide: {
        type: 'topDestinationsWorldwide',
        title: 'Ən yaxşı beynəlxalq istiqamətlər',
      },
    },
    {
      PopularCountries: {
        type: 'popularCountries',
        title: 'Populyar ölkələr',
      },
    },
  ],
  it: [
    {
      topDomesticFlight: {
        type: 'topDomesticFlights',
        title: 'Voli nazionali popolari',
      },
    },
    {
      TopDestinationsWorldwide: {
        type: 'topDestinationsWorldwide',
        title: 'Le migliori destinazioni nel mondo',
      },
    },
    {
      PopularCountries: {
        type: 'popularCountries',
        title: 'Paesi popolari',
      },
    },
  ],
  fr: [
    {
      topDomesticFlight: {
        type: 'topDomesticFlights',
        title: 'Vols domestiques populaires',
      },
    },
    {
      TopDestinationsWorldwide: {
        type: 'topDestinationsWorldwide',
        title: 'Meilleures destinations mondiales',
      },
    },
    {
      PopularCountries: {
        type: 'popularCountries',
        title: 'Pays populaires',
      },
    },
  ],
  pt: [
    {
      topDomesticFlight: {
        type: 'topDomesticFlights',
        title: 'Voos domésticos populares',
      },
    },
    {
      TopDestinationsWorldwide: {
        type: 'topDestinationsWorldwide',
        title: 'Principais destinos mundiais',
      },
    },
    {
      PopularCountries: {
        type: 'popularCountries',
        title: 'Países populares',
      },
    },
  ],
  ro: [
    {
      topDomesticFlight: {
        type: 'topDomesticFlights',
        title: 'Zboruri interne populare',
      },
    },
    {
      TopDestinationsWorldwide: {
        type: 'topDestinationsWorldwide',
        title: 'Destinații de top în întreaga lume',
      },
    },
    {
      PopularCountries: {
        type: 'popularCountries',
        title: 'Țări populare',
      },
    },
  ],
  pl: [
    {
      topDomesticFlight: {
        type: 'topDomesticFlights',
        title: 'Popularne loty krajowe',
      },
    },
    {
      TopDestinationsWorldwide: {
        type: 'topDestinationsWorldwide',
        title: 'Najlepsze destynacje na świecie',
      },
    },
    {
      PopularCountries: {
        type: 'popularCountries',
        title: 'Popularne kraje',
      },
    },
  ],
  lt: [
    {
      topDomesticFlight: {
        type: 'topDomesticFlights',
        title: 'Populiarūs vidaus skrydžiai',
      },
    },
    {
      TopDestinationsWorldwide: {
        type: 'topDestinationsWorldwide',
        title: 'Geriausi pasaulio kryptys',
      },
    },
    {
      PopularCountries: {
        type: 'popularCountries',
        title: 'Populiarios šalys',
      },
    },
  ],
  uz: [
    {
      topDomesticFlight: {
        type: 'topDomesticFlights',
        title: 'Mashhur ichki parvozlar',
      },
    },
    {
      TopDestinationsWorldwide: {
        type: 'topDestinationsWorldwide',
        title: "Dunyoning eng yaxshi yo'nalishlari",
      },
    },
    {
      PopularCountries: {
        type: 'popularCountries',
        title: 'Mashhur davlatlar',
      },
    },
  ],
  sr: [
    {
      topDomesticFlight: {
        type: 'topDomesticFlights',
        title: 'Popularna domaća leta',
      },
    },
    {
      TopDestinationsWorldwide: {
        type: 'topDestinationsWorldwide',
        title: 'Najpopularniji svetski odredišta',
      },
    },
    {
      PopularCountries: {
        type: 'popularCountries',
        title: 'Popularne zemlje',
      },
    },
  ],
  ky: [
    {
      topDomesticFlight: {
        type: 'topDomesticFlights',
        title: 'Популярдуу ички учуулар',
      },
    },
    {
      TopDestinationsWorldwide: {
        type: 'topDestinationsWorldwide',
        title: 'Дүйнөдөгү мыкты багыттар',
      },
    },
    {
      PopularCountries: {
        type: 'popularCountries',
        title: 'Популярдуу өлкөлөр',
      },
    },
  ],
  tg: [
    {
      topDomesticFlight: {
        type: 'topDomesticFlights',
        title: 'Парвозҳои маҳаллии маъмул',
      },
    },
    {
      TopDestinationsWorldwide: {
        type: 'topDestinationsWorldwide',
        title: 'Беҳтарин самтҳои ҷаҳонӣ',
      },
    },
    {
      PopularCountries: {
        type: 'popularCountries',
        title: 'Кишварҳои маъмул',
      },
    },
  ],
  kk: [
    {
      topDomesticFlight: {
        type: 'topDomesticFlights',
        title: 'Танымал ішкі рейстер',
      },
    },
    {
      TopDestinationsWorldwide: {
        type: 'topDestinationsWorldwide',
        title: 'Әлемдік топ бағыттар',
      },
    },
    {
      PopularCountries: {
        type: 'popularCountries',
        title: 'Танымал елдер',
      },
    },
  ],
  nl: [
    {
      topDomesticFlight: {
        type: 'topDomesticFlights',
        title: 'Populaire binnenlandse vluchten',
      },
    },
    {
      TopDestinationsWorldwide: {
        type: 'topDestinationsWorldwide',
        title: 'Top bestemmingen wereldwijd',
      },
    },
    {
      PopularCountries: {
        type: 'popularCountries',
        title: 'Populaire landen',
      },
    },
  ],
  zh: [
    {
      topDomesticFlight: {
        type: 'topDomesticFlights',
        title: '热门国内航班',
      },
    },
    {
      TopDestinationsWorldwide: {
        type: 'topDestinationsWorldwide',
        title: '全球热门目的地',
      },
    },
    {
      PopularCountries: {
        type: 'popularCountries',
        title: '热门国家',
      },
    },
  ],
  ka: [
    {
      topDomesticFlight: {
        type: 'topDomesticFlights',
        title: 'პოპულარული შიდა ფრენები',
      },
    },
    {
      TopDestinationsWorldwide: {
        type: 'topDestinationsWorldwide',
        title: 'მსოფლიოს ტოპ მიმართულებები',
      },
    },
    {
      PopularCountries: {
        type: 'popularCountries',
        title: 'პოპულარული ქვეყნები',
      },
    },
  ],
  hi: [
    {
      topDomesticFlight: {
        type: 'topDomesticFlights',
        title: 'लोकप्रिय घरेलू उड़ानें',
      },
    },
    {
      TopDestinationsWorldwide: {
        type: 'topDestinationsWorldwide',
        title: 'विश्वव्यापी शीर्ष गंतव्य',
      },
    },
    {
      PopularCountries: {
        type: 'popularCountries',
        title: 'लोकप्रिय देश',
      },
    },
  ],
  ja: [
    {
      topDomesticFlight: {
        type: 'topDomesticFlights',
        title: '人気の国内フライト',
      },
    },
    {
      TopDestinationsWorldwide: {
        type: 'topDestinationsWorldwide',
        title: '世界のトップ目的地',
      },
    },
    {
      PopularCountries: {
        type: 'popularCountries',
        title: '人気の国',
      },
    },
  ],
  ko: [
    {
      topDomesticFlight: {
        type: 'topDomesticFlights',
        title: '인기 국내선 항공편',
      },
    },
    {
      TopDestinationsWorldwide: {
        type: 'topDestinationsWorldwide',
        title: '전 세계 인기 목적지',
      },
    },
    {
      PopularCountries: {
        type: 'popularCountries',
        title: '인기 국가',
      },
    },
  ],
  ur: [
    {
      topDomesticFlight: {
        type: 'topDomesticFlights',
        title: 'مقبول ملکی پروازیں',
      },
    },
    {
      TopDestinationsWorldwide: {
        type: 'topDestinationsWorldwide',
        title: 'عالمی سرفہرست مقامات',
      },
    },
    {
      PopularCountries: {
        type: 'popularCountries',
        title: 'مقبول ممالک',
      },
    },
  ],
  ta: [
    {
      topDomesticFlight: {
        type: 'topDomesticFlights',
        title: 'பிரபலமான உள்நாட்டு விமானங்கள்',
      },
    },
    {
      TopDestinationsWorldwide: {
        type: 'topDestinationsWorldwide',
        title: 'உலகின் சிறந்த இடங்கள்',
      },
    },
    {
      PopularCountries: {
        type: 'popularCountries',
        title: 'பிரபலமான நாடுகள்',
      },
    },
  ],
  th: [
    {
      topDomesticFlight: {
        type: 'topDomesticFlights',
        title: 'เที่ยวบินภายในประเทศยอดนิยม',
      },
    },
    {
      TopDestinationsWorldwide: {
        type: 'topDestinationsWorldwide',
        title: 'จุดหมายปลายทางยอดนิยมทั่วโลก',
      },
    },
    {
      PopularCountries: {
        type: 'popularCountries',
        title: 'ประเทศยอดนิยม',
      },
    },
  ],
}
